import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import uploadPhoto from "../../../../../Image/upload 1.png";
import { Box, Container, TextField, Typography } from "@material-ui/core";
import "../AdminCommonPages.css";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const AddArticle = () => {
  //   const classes = useStyles();
  const [desc, setDesc] = useState(null);
  const [title, setTitle] = useState(null);
  const [file, setFile] = useState(null);
  const navigate = useNavigate();
  const notify = () => {
    toast.success("Successfully Added !", {
      position: toast.POSITION.TOP_CENTER,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const newData = {
      title,
      desc,
    };

    if (file) {
      const data = new FormData();
      const fileName = Date.now() + file.name;
      data.append("name", fileName);
      data.append("file", file);
      newData.image = fileName;
      console.log(newData);
      try {
        await axios.post("https://abc-backend.onrender.com/api/upload", data);
      } catch (err) {}
    }
    try {
      //abc-backend.onrender.com/api/articles/image
      await axios
        .post("https://abc-backend.onrender.com/api/articles/article", newData)
        .then((res) => {
          if (res.data) {
            notify();
            navigate("/siteadmin/article");
            window.location.reload();
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className={"edit_article_main"} style={{ marginTop: "80px" }}>
      <Container>
        <Typography variant="h2">Add Article</Typography>
        <Box>
          <form
            noValidate
            autoComplete="off"
            className="type_form"
            onSubmit={handleSubmit}
          >
            <div className="upload_img_init">
              <input
                accept="image/*"
                style={{ display: "none" }}
                id="image"
                type="file"
                name="image"
                onChange={(e) => setFile(e.target.files[0])}
              />
              <label htmlFor="image" className="upload_img_text">
                <img
                  src={uploadPhoto}
                  alt="uploadPhoto"
                  className="uploading_img"
                />
                <span>Add image</span>
              </label>
            </div>
            <Box>
              <label htmlFor="">Article Title</label>
              <br />
              <br />
              <TextField
                variant="outlined"
                id="title"
                onChange={(e) => setTitle(e.target.value)}
              />
            </Box>
            <Box>
              <label htmlFor="">Article Description</label>
              <br />
              <br />
              <TextField
                variant="outlined"
                id="desc"
                onChange={(e) => setDesc(e.target.value)}
              />
            </Box>
            <Box className="type_submit_btn">
              <button className="common-btn" type="submit">
                Add
              </button>
            </Box>
          </form>
        </Box>
        <ToastContainer />
      </Container>
    </div>
  );
};

export default AddArticle;
